import React from "react";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";
import { Calendar } from "./calendar";

type DateSelectProps = React.ComponentProps<typeof PopoverTrigger> & {
  selected?: Date;
  onSelect?: (date: Date | undefined) => void;
  disabledDays?: (date: Date) => boolean;
};

export function DateSelect({ selected, onSelect, disabledDays,...props }: DateSelectProps) {
  const [open, setOpen] = React.useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen} modal={false}>
      <PopoverTrigger asChild {...props} />
      <PopoverContent>
        <Calendar
          mode="single"
          selected={selected}
          disabled={disabledDays}
          onSelect={(date) => { onSelect?.(date); setOpen(false); }}
          className="w-full"
        />
      </PopoverContent>
    </Popover>
  );
}
